<template>
    <div id="aboutusDiv">
        <HeaderVue />
        <div class="inner-page">
            <div class="container">
                <div class="row">
                    <div class="col-sm-3">
                        <!-- Side menu vue components @/components/Public/Sidemenu -->
                        <Sidemenu />
                    </div>
                    <div class="col-sm-9">
                        <h3>About Us</h3>
                        <p>Labotist is a convenient, technology driven platform that serves as a one stop solution for patients
                            to easily choose from, and connect with various labs across the city. It is an online marketplace for lab services, 
                            offering patients the convenience of making their choice based on location, cost
                            of test, quality and turnaround time. Patients also enjoy the added luxury of getting their samples
                            collected in the comforts of their home by a trained phlebotomist.</p>

                        <h3>How does it work?</h3>
                        <img src="static/images/about-us.svg" class="img-fluid full-width" alt="">
                        <p>Patients can visit labotist.com and research for the specific test and profiles that need to be done.
                            Labotist.com is a lab aggregator and shares all the relevant details, including price, discounts
                            if any, quality and certifications, typical turnaround time etc. Based on the results, patients
                            can then choose the lab they would like to engage with.</p>

                        <p>Once a lab has been selected, patients can schedule home sample collection requests at a convenient
                            date & time. The request gets transmitted to all registered and certified phlebotomists operating
                            in the area. On the Phlebotomist mobile app, the Phlebotomists can accept the request based on
                            their convenience and availability. Once accepted, the request is then automatically scheduled
                            in Phlebotomist’s calendar. When the phlebotomist goes to the patient’s house for sample collection,
                            the mobile app enables technology guided sample collection process thereby ensuring safety &
                            accuracy throughout the process. Phlebotomists then deliver the sample to lab chosen by the patient.</p>

                        <p>After processing the samples, the partnering lab then sends the reports to Labotist. Once verified,
                            the reports are then delivered to the patients, on the Patient Web App. Here, patients can store
                            and access at once, all the lab reports that have been processed by Labotist (across the different
                            labs they have opted thus far through Labotist).</p>
                    </div>
                </div>
            </div>
        </div>
        <FooterVue />
    </div>
</template>

<script>
import HeaderVue from '@/components/web/Header'
import FooterVue from '@/components/web/Footer'
import Sidemenu from '@/components/web/Public/Sidemenu'

export default {
  name: 'Aboutus',
  data () {
    return {}
  },
  components: {
    HeaderVue,
    Sidemenu,
    FooterVue
  },
  beforeCreate () { },
  mounted () {
    this.$hidePageLoading()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/web/Public/Aboutus.vue